import { create } from 'zustand'
import { fetchMemos, fetchMemo, searchMemosFromCache, type LinkedMemo } from '@/services/memoBridge'

interface MemoLinkState {
  memoUid: string | null
  memos: LinkedMemo[]
  isLoading: boolean
  isConnected: boolean
  _initId: number

  initialize: (memoUid: string) => Promise<void>
  refreshMemos: () => Promise<void>
  getMemo: (syncId: string) => Promise<LinkedMemo | null>
  search: (keyword: string) => LinkedMemo[]
  cleanup: () => void
}

export const useMemoLinkStore = create<MemoLinkState>()((set, get) => ({
  memoUid: null,
  memos: [],
  isLoading: false,
  isConnected: false,
  _initId: 0,

  initialize: async (memoUid) => {
    // 동시 실행 방지: 세대 ID로 최신 호출만 상태 반영
    const initId = Date.now()
    set({ memoUid, isLoading: true, _initId: initId })
    try {
      console.info('[MemoLinkStore] fetchMemos 시작, uid:', memoUid)
      const memos = await fetchMemos(memoUid)
      console.info('[MemoLinkStore] fetchMemos 결과:', memos.length, '건')
      // 비동기 완료 후: 이 호출이 아직 최신인지 확인
      if (get()._initId !== initId) {
        console.warn('[MemoLinkStore] stale initId, 결과 무시')
        return
      }
      set({ memos, isConnected: true, isLoading: false })
    } catch (err) {
      console.error('[MemoLinkStore] fetchMemos 실패:', err)
      if (get()._initId !== initId) return
      set({ isConnected: false, isLoading: false })
    }
  },

  refreshMemos: async () => {
    const { memoUid } = get()
    if (!memoUid) return
    set({ isLoading: true })
    try {
      const memos = await fetchMemos(memoUid)
      set({ memos, isLoading: false })
    } catch (err) {
      console.error('Failed to refresh memos:', err)
      set({ isLoading: false })
    }
  },

  getMemo: async (syncId) => {
    const { memoUid } = get()
    if (!memoUid) return null
    return fetchMemo(memoUid, syncId)
  },

  search: (keyword) => {
    return searchMemosFromCache(get().memos, keyword)
  },

  cleanup: () => set({ memoUid: null, memos: [], isConnected: false, isLoading: false, _initId: 0 }),
}))
